export const questConfig = {
    data() {
        return {
            eventId: {
                1: '提升等级',
                2: '穿戴装备',
                3: '存档',
                4: '升级天赋',
                5: '强化装备',
                6: '重铸装备',
                // 7: '切换地图',
                8: '使用药剂',
                9: '锁定/解锁装备',
                10: '分解装备',
                11: '合成铜锭',
                12: '锻造装备',
                13: '挑战副本',
                14: '招募成员',
                15: '使用练功房',
                101: '升级公会',
                102: '升级酒馆',
                103: '升级任务榜',
                104: '升级商店',
                105: '升级黑市',
                106: '升级铁匠铺',
                107: '升级练功房',
                108: '升级中级练功房',
                109: '升级高级练功房',
                110: '升级矿场',
                111: '升级药园',
                112: '升级金库'
            },
            rewardType: {gold: '金币', guildReputation: '公会名望'},
            questCategory: {
                undefined: '其他',
                newbie: '新手指引',
                guild: '公会任务',
                repeat: '循环'
            },
            questBoardList: [
                [],
                [1000, 1002, 1010, 1012, 1019 ],
                [1020, 1022, 1030, 1032, 1039 ],
                [1040, 1043, 1050, 1053, 1059 ],
                [1060, 1063, 1070, 1073, 1079 ],
                [1080, 1083, 1090, 1093, 1099 ]
            ],
            questList: {
                1: {
                    name: '击败训练假人',
                    category: 'newbie',
                    desc: '在游戏界面中间位置, 找到"开始战斗", 尝试开始你的第一次战斗吧! 战斗胜利后, 如果当前等级低于目标等级, 会提升到目标等级, 每次升级还会获得1点全属性',
                    target: '击败1只1级的训练假人',
                    lv: 1,
                    reqs: [['slain', 1, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['helmet']}]],
                    successor: [2, 7],
                    forfeit: false
                },
                2: {
                    name: '提升等级到5级',
                    category: 'newbie',
                    desc: '试着再击败四只训练假人吧, 将等级提升到5级! ',
                    target: '提升等级到5级',
                    lv: 2,
                    reqs: [['event', 1, 5]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['necklace']}]],
                    successor: [3, 4],
                    forfeit: false
                },
                3: {
                    name: '击败训练假人精英',
                    category: 'newbie',
                    desc: '击败一只训练假人精英, 在游戏界面中间位置, 切换"精英"区, 再点击"开始战斗"。失败了不要紧, 怪物不会回血! 精英每次被击败后等级会提升5级',
                    target: '击败训练假人精英',
                    lv: 5,
                    reqs: [['slain', 3, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['shoulder']}]],
                    successor: [],
                    forfeit: false
                },
                4: {
                    name: '击败冰霜训练假人',
                    category: 'newbie',
                    desc: '试着击败一只冰霜训练假人吧。点击"BOSS"右边的刷新键可切换区域怪物类型。 普通区的怪物将转换为冰霜训练假人, 使用法术攻击。',
                    target: '击败冰霜训练假人',
                    lv: 5,
                    reqs: [['slain', 2, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['ring']}]],
                    successor: [5],
                    forfeit: false
                },
                5: {
                    name: '击败冰霜训练假人精英',
                    category: 'newbie',
                    desc: '击败1只冰霜训练假人精英吧, 比起普通区怪物, 精英一般会拥有一个技能。训练假人没有, 因为他们是训练假人。',
                    target: '击败冰霜训练假人精英',
                    lv: 10,
                    reqs: [['slain', 4, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['glove']}]],
                    successor: [6, 11],
                    forfeit: false
                },
                6: {
                    name: '毕业',
                    category: 'newbie',
                    desc: '在游戏界面中间位置, 切换"BOSS"区! BOSS类怪物奖励非常丰富! BOSS每次被击败后等级会一次性提升10级',
                    target: '击败导师',
                    lv: 10,
                    reqs: [['slain', 5, 1]],
                    rewardItem: [['unique_equip', 'inv_sword_05', 1, 100], ['unique_equip', 'inv_wand_06', 1, 100]],
                    successor: [],
                    forfeit: false
                },
                7: {
                    name: '穿戴装备',
                    category: 'newbie',
                    desc: '打开左下角的【背包】(快捷键B), 在【装备】分类下双击或者右键装备单击装备, 即可穿戴或更换装备',
                    target: '穿戴一件装备',
                    lv: 1,
                    reqs: [['event', 2, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['bracer']}]],
                    successor: [8],
                    forfeit: false
                },
                8: {
                    name: '存档',
                    category: 'newbie',
                    desc: '点击左下角的【保存/加载游戏】(快捷键S), 点击后自动进行一次存档, 平时每5分钟自动存档一次',
                    target: '保存一次游戏进度',
                    lv: 1,
                    reqs: [['event', 3, 1]],
                    rewardItem: [['inv_alchemy_80_potion01red', 20, 100]],
                    successor: [10],
                    forfeit: false
                },
                10: {
                    name: '使用药剂',
                    category: 'newbie',
                    desc: '打开背包, 在上方切换至【消耗】, 在战斗外使用一次特效生命药水恢复生命值 ',
                    target: '使用一次药剂',
                    lv: 1,
                    reqs: [['event', 8, 1]],
                    rewardItem: [['inv_alchemy_80_potion01red', 20, 100], ['inv_alchemy_80_potion01blue', 20, 100]],
                    successor: [],
                    forfeit: false
                },
                11: {
                    name: '击败癞皮山猪',
                    category: 'newbie',
                    desc: '10级后, 每50级更换一次地区, 每个地区的普通、精英、BOSS会更换',
                    target: '击败癞皮山猪',
                    lv: 10,
                    reqs: [['slain', 12, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['belt']}]],
                    successor: [12],
                    forfeit: false
                },
                12: {
                    name: '击败癞皮山猪精英',
                    category: 'newbie',
                    desc: '精英比起普通怪物会多出一个技能, 癞皮山猪精英的技能是头槌, 可造成攻击力*1.2点伤害, 有20%眩晕目标',
                    target: '击败1只癞皮山猪精英',
                    lv: 15,
                    reqs: [['slain', 14, 1]],
                    rewardItem: [['random_equip_elite_1', 1, 100]],
                    successor: [13],
                    forfeit: false
                },
                13: {
                    name: '实力的证明',
                    category: 'newbie',
                    desc: 'BOSS拥有更多的技能, 击败阿迦玛可获得创建公会的资格。打不过? 可以考虑降低怪物等级, 刷点装备再来',
                    target: '击败阿迦玛',
                    lv: 20,
                    reqs: [['slain', 15, 1]],
                    rewardItem: [['inv_misc_bone_06', 1, 100]],
                    successor: [27],
                    forfeit: false
                },
                15: {
                    name: '升级天赋',
                    category: 'newbie',
                    desc: '每击败一次最高级的精英可获得一点天赋点数, 每击败一次最高级的BOSS可获得两点。点击左上角的【天赋】切换到天赋界面。左键点击天赋可提升一级, 右键降低一级, 按住shift一次5级。如果想要使用法术攻击, 可升级一次法师的寒冰箭(第三组第一排第一个)',
                    target: '升级一次天赋',
                    lv: 10,
                    reqs: [['event', 4, 1]],
                    rewardItem: [['random_equip_normal_0', 1, 100, {types: ['cape']}]],
                    successor: [],
                    forfeit: false
                },
                16: {
                    name: '强化装备',
                    category: 'newbie',
                    desc: '一级铁匠铺后可强化装备, 右键身上的或者背包的装备点击强化。每强化一级提升20%基础属性(向下取整)。',
                    target: '提升一次装备强化等级',
                    lv: 10,
                    reqs: [['event', 5, 1]],
                    rewardItem: [['inv_misc_gem_diamond_04', 5, 100]],
                    successor: [17],
                    forfeit: false
                },
                17: {
                    name: '锁定/解锁装备',
                    category: 'newbie',
                    desc: '在背包中右键点击装备, 可锁定/解锁装备。装备强化后自动锁定, 被锁定的装备无法出售/不会被出售。',
                    target: '锁定/解锁装备',
                    lv: 10,
                    reqs: [['event', 9, 1]],
                    reward: [['gold', 500]],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                18: {
                    name: '重铸装备',
                    category: 'newbie',
                    desc: '公会铁匠铺2级解锁重铸功能。右键点击装备图标, 选择重铸。可一次性重置装备所有的额外词条, 或者额外花费金币锁定部分词条后重置剩下词条。',
                    target: '重铸一次装备',
                    lv: 20,
                    reqs: [['event', 6, 1]],
                    reward: [['gold', 2000]],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                19: {
                    name: '下副本',
                    category: 'newbie',
                    desc: '左下角新增的【副本】(快捷键D)功能, 通过挑战副本获取材料、提升成员等级。点击【名称】前面的0/5可快速选人、取消选择',
                    target: '挑战一次副本',
                    lv: 15,
                    reqs: [['event', 13, 1]],
                    reward: [['gold', 2000]],
                    rewardItem: [['inv_misc_note_06', 5, 100]],
                    successor: [],
                    forfeit: false
                },
                20: {
                    name: '分解装备',
                    category: 'newbie',
                    desc: '公会铁匠铺1级解锁分解功能, 背包右键装备可分解品质破旧以上的装备',
                    target: '分解一件装备',
                    lv: 20,
                    reqs: [['event', 10, 1]],
                    reward: [['gold', 500]],
                    rewardItem: [['inv_ore_copper_01', 12, 100]],
                    successor: [21],
                    forfeit: false
                },
                21: {
                    name: '合成铜锭',
                    category: 'newbie',
                    desc: '左下角新增的【锻造】(快捷键C)功能, 选择【矿物】, 使用铜矿石合成四次铜锭',
                    target: '合成4个铜锭',
                    lv: 20,
                    reqs: [['event', 11, 4]],
                    reward: [['gold', 500]],
                    rewardItem: [['dust3', 10, 100]],
                    successor: [22],
                    forfeit: false
                },
                22: {
                    name: '合成装备',
                    category: 'newbie',
                    desc: '打开左下角【锻造】功能, 选择【打造】, 选择【随机罕见装备】以及装备类型, 使用10份罕见装备精华打造一件随机罕见装备, 记得添加4块铜锭增加成品的装备等级。',
                    target: '打造装备',
                    lv: 20,
                    reqs: [['event', 12, 1]],
                    reward: [['gold', 2000]],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                22: {
                    name: '扩大工会',
                    category: 'guild',
                    desc: '在【公会】选项下切换至【酒馆】可以招募成员进行地下城挑战, 酒馆每5分钟刷新一次, 一级公会最多可容纳15人',
                    target: '招募成员',
                    lv: 20,
                    reqs: [['event', 14, 1]],
                    reward: [['gold', 2000]],
                    rewardItem: [],
                    successor: [19],
                    forfeit: false
                },
                23: {
                    name: '训练',
                    category: 'guild',
                    desc: '在【公会】选项下切换至【练功房】可以使用练功房进行训练, 时间结束后可提升属性, 时间越长提升越多, 不需要保持游戏在线',
                    target: '使用练功房',
                    lv: 20,
                    reqs: [['event', 15, 1]],
                    reward: [['gold', 2000]],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                25: {
                    name: '夺回矿场',
                    category: 'guild',
                    desc: '矿场被狗头人矿工霸占了, 击败他们夺回矿场。（矿场可将地图上的矿托管自动挖矿）',
                    target: '击败5个狗头人矿工精英',
                    lv: 25,
                    reqs: [['slain', 23, 5]],
                    rewardItem: [['inv_misc_note_06_mine', 1, 100]],
                    successor: [26],
                    forfeit: false
                },
                26: {
                    name: '打败幕后黑手',
                    category: 'guild',
                    desc: '狗头人矿工只是打工仔, 金牙才是幕后黑手, 击败他夺回剩下的矿场。',
                    target: '击败金牙',
                    lv: 20,
                    reqs: [['slain', 25, 1]],
                    rewardItem: [['inv_misc_note_06_mine', 1, 100]],
                    successor: [],
                    forfeit: false
                },
                27: {
                    name: '实力的证明II',
                    category: 'newbie',
                    desc: '击败金牙证明自己的实力, 获得拥有二级公会的许可。',
                    target: '击败金牙',
                    lv: 50,
                    reqs: [['slain', 25, 1]],
                    rewardItem: [['inv_misc_note_06_guild', 1, 100]],
                    successor: [36],
                    forfeit: false
                },
                36: {
                    name: '实力的证明III',
                    category: 'newbie',
                    desc: '击败霍格证明自己的实力, 获得拥有三级公会的许可',
                    target: '击败霍格',
                    lv: 150,
                    reqs: [['slain', 35, 1]],
                    rewardItem: [['inv_misc_note_06_guild', 1, 100]],
                    successor: [46],
                    forfeit: false
                },
                46: {
                    name: '实力的证明IV',
                    category: 'newbie',
                    desc: '击败铁背龟证明自己的实力, 获得拥有四级公会的许可',
                    target: '击败铁背龟',
                    lv: 200,
                    reqs: [['slain', 45, 1]],
                    rewardItem: [['inv_misc_note_06_guild', 1, 100]],
                    successor: [56],
                    forfeit: false
                },
                56: {
                    name: '实力的证明V',
                    category: 'newbie',
                    desc: '击败熔岩元素证明自己的实力, 获得拥有五级公会的许可',
                    target: '击败熔岩元素',
                    lv: 250,
                    reqs: [['slain', 55, 1]],
                    rewardItem: [['inv_misc_note_06_guild', 1, 100]],
                    successor: [],
                    forfeit: false
                },
                100: {
                    name: '升级酒馆I',
                    category: 'guild',
                    desc: '酒馆可以招募公会成员进行副本探索, 获取各种材料',
                    target: '升级酒馆至1级',
                    lv: 20,
                    reqs: [['event', 102, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [22],
                    forfeit: false
                },
                110: {
                    name: '升级任务榜I',
                    category: 'guild',
                    desc: '公会任务榜发放怪物讨伐任务，可以获得金币以及公会名望',
                    target: '升级任务榜至1级',
                    lv: 20,
                    reqs: [['event', 103, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                120: {
                    name: '升级商店I',
                    category: 'guild',
                    desc: '商店可以使用金币、公会名望购买各类产品',
                    target: '升级商店至1级',
                    lv: 20,
                    reqs: [['event', 104, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                121: {
                    name: '升级商店II',
                    category: 'guild',
                    desc: '升级商店至2级。',
                    target: '升级商店至2级',
                    lv: 20,
                    reqs: [['event', 104, 2]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                122: {
                    name: '升级商店III',
                    category: 'guild',
                    desc: '升级商店至3级。',
                    target: '升级商店至3级',
                    lv: 20,
                    reqs: [['event', 104, 3]],
                    reward: [],
                    rewardItem: [],
                    successor: [130],
                    forfeit: false
                },
                130: {
                    name: '升级黑市I',
                    category: 'guild',
                    desc: '黑市随机出售各种来路不明的装备, 里面不乏各种极品装备',
                    target: '升级黑市至1级',
                    lv: 20,
                    reqs: [['event', 105, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                140: {
                    name: '升级铁匠铺I',
                    category: 'guild',
                    desc: '铁匠铺可以对装备进行强化，提升装备的基础属性',
                    target: '升级铁匠铺至1级',
                    lv: 20,
                    reqs: [['event', 106, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [16, 141],
                    forfeit: false
                },
                141: {
                    name: '升级铁匠铺II',
                    category: 'guild',
                    desc: '二级铁匠铺可以对装备进行锻造，修改装备的额外属性',
                    target: '升级铁匠铺至2级',
                    lv: 20,
                    reqs: [['event', 106, 2]],
                    reward: [],
                    rewardItem: [],
                    successor: [18, 142],
                    forfeit: false
                },
                142: {
                    name: '升级铁匠铺III',
                    category: 'guild',
                    desc: '三级铁匠铺可以开始消耗材料打造装备',
                    target: '升级铁匠铺至3级',
                    lv: 20,
                    reqs: [['event', 106, 3]],
                    reward: [],
                    rewardItem: [],
                    successor: [20],
                    forfeit: false
                },
                150: {
                    name: '升级练功房I',
                    category: 'guild',
                    desc: '升级练功房至1级。',
                    target: '升级练功房至1级',
                    lv: 20,
                    reqs: [['event', 107, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [23],
                    forfeit: false
                },
                160: {
                    name: '升级中级练功房I',
                    category: 'guild',
                    desc: '升级中级练功房至1级。',
                    target: '升级中级练功房至1级',
                    lv: 20,
                    reqs: [['event', 108, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                170: {
                    name: '升级高级练功房I',
                    category: 'guild',
                    desc: '升级高级练功房至1级。',
                    target: '升级高级练功房至1级',
                    lv: 20,
                    reqs: [['event', 109, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                180: {
                    name: '升级矿场I',
                    category: 'guild',
                    desc: '升级矿场至1级。',
                    target: '升级矿场至1级',
                    lv: 20,
                    reqs: [['event', 110, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                190: {
                    name: '升级药园I',
                    category: 'guild',
                    desc: '升级药园至1级。',
                    target: '升级药园至1级',
                    lv: 20,
                    reqs: [['event', 111, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                200: {
                    name: '升级金库I',
                    category: 'guild',
                    desc: '金库可以提升获取的金币数量',
                    target: '升级金库至1级',
                    lv: 20,
                    reqs: [['event', 112, 1]],
                    reward: [],
                    rewardItem: [],
                    successor: [],
                    forfeit: false
                },
                1000: {
                    name: '魔物扫荡：杂斑野猪',
                    category: 'repeat',
                    desc: '清理克罗莫丹周边的魔物',
                    target: '击败20只杂斑野猪',
                    lv: 15,
                    reqs: [['slain', 11, 20]],
                    reward: [['gold', 2000], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_2', 1, 100]],
                    successor: [1000],
                    forfeit: false
                },
                1002: {
                    name: '魔物扫荡：杂斑野猪精英',
                    category: 'repeat',
                    desc: '清理克罗莫丹周边的魔物',
                    target: '击败10只杂斑野猪精英',
                    lv: 15,
                    reqs: [['slain', 13, 10]],
                    reward: [['gold', 3000], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 17}]],
                    successor: [1002],
                    forfeit: false
                },
                1010: {
                    name: '魔物扫荡：癞皮山猪',
                    category: 'repeat', 
                    desc: '清理克罗莫丹周边的魔物',
                    target: '击败20只癞皮山猪',
                    lv: 20,
                    reqs: [['slain', 12, 20]],
                    reward: [['gold', 3000], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_2', 1, 100]],
                    successor: [1010],
                    forfeit: false
                },
                1012: {
                    name: '魔物扫荡：癞皮山猪精英',
                    category: 'repeat', 
                    desc: '清理克罗莫丹周边的魔物',
                    target: '击败10只癞皮山猪精英',
                    lv: 20,
                    reqs: [['slain', 14, 10]],
                    reward: [['gold', 6000], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 22}]],
                    successor: [1012],
                    forfeit: false
                },
                1019: {
                    name: '魔物扫荡：阿迦玛',
                    category: 'repeat', 
                    desc: '击败克罗莫丹地区首领',
                    target: '击败5只阿迦玛',
                    lv: 20,
                    reqs: [['slain', 15, 5]],
                    reward: [['gold', 10000], ['guildReputation', 50]],
                    rewardItem: [['random_equip_6', 1, 100]],
                    successor: [1019],
                    forfeit: false
                },
                1020: {
                    name: '魔物扫荡：狗头人矿工',
                    category: 'repeat',
                    desc: '清理艾尔文森林周边的魔物',
                    target: '击败50只狗头人矿工',
                    lv: 25,
                    reqs: [['slain', 21, 50]],
                    reward: [['gold', 6000], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_2', 1, 100]],
                    successor: [1020],
                    forfeit: false
                },
                1022: {
                    name: '魔物扫荡：狗头人矿工精英',
                    category: 'repeat',
                    desc: '清理艾尔文森林周边的魔物',
                    target: '击败10只狗头人矿工精英',
                    lv: 25,
                    reqs: [['slain', 23, 10]],
                    reward: [['gold', 9000], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 27}]],
                    successor: [1022],
                    forfeit: false
                },
                1030: {
                    name: '魔物扫荡：狗头人地卜师',
                    category: 'repeat', 
                    desc: '清理艾尔文森林周边的魔物',
                    target: '击败50只狗头人地卜师',
                    lv: 30,
                    reqs: [['slain', 22, 50]],
                    reward: [['gold', 7200], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_2', 1, 100]],
                    successor: [1030],
                    forfeit: false
                },
                1032: {
                    name: '魔物扫荡：狗头人地卜师精英',
                    category: 'repeat', 
                    desc: '清理艾尔文森林周边的魔物',
                    target: '击败10只狗头人地卜师精英',
                    lv: 30,
                    reqs: [['slain', 24, 10]],
                    reward: [['gold', 10800], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 32}]],
                    successor: [1032],
                    forfeit: false
                },
                1039: {
                    name: '魔物扫荡：金牙',
                    category: 'repeat', 
                    desc: '击败艾尔文森林地区首领',
                    target: '击败5只金牙',
                    lv: 30,
                    reqs: [['slain', 25, 5]],
                    reward: [['gold', 40000], ['guildReputation', 50]],
                    rewardItem: [['random_equip_6', 1, 100]],
                    successor: [1039],
                    forfeit: false
                },
                1040: {
                    name: '魔物扫荡：河爪豺狼人',
                    category: 'repeat',
                    desc: '清理西部荒野周边的魔物',
                    target: '击败50只河爪豺狼人',
                    lv: 35,
                    reqs: [['slain', 31, 50]],
                    reward: [['gold', 9000], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_2', 1, 100]],
                    successor: [1040],
                    forfeit: false
                },
                1043: {
                    name: '魔物扫荡：河爪豺狼人精英',
                    category: 'repeat',
                    desc: '清理西部荒野周边的魔物',
                    target: '击败10只河爪豺狼人精英',
                    lv: 35,
                    reqs: [['slain', 33, 10]],
                    reward: [['gold', 13500], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 37}]],
                    successor: [1043],
                    forfeit: false
                },
                1050: {
                    name: '魔物扫荡：黑爪豺狼人',
                    category: 'repeat', 
                    desc: '清理西部荒野周边的魔物',
                    target: '击败50只黑爪豺狼人',
                    lv: 40,
                    reqs: [['slain', 32, 10]],
                    reward: [['gold', 10800], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_2', 1, 100]],
                    successor: [1050],
                    forfeit: false
                },
                1053: {
                    name: '魔物扫荡：黑爪豺狼人精英',
                    category: 'repeat', 
                    desc: '清理西部荒野周边的魔物',
                    target: '击败10只黑爪豺狼人精英',
                    lv: 40,
                    reqs: [['slain', 34, 10]],
                    reward: [['gold', 16200], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 42}]],
                    successor: [1053],
                    forfeit: false
                },
                1059: {
                    name: '魔物扫荡：霍格',
                    category: 'repeat', 
                    desc: '击败西部荒野地区首领',
                    target: '击败5只霍格',
                    lv: 40,
                    reqs: [['slain', 35, 5]],
                    reward: [['gold', 60000], ['guildReputation', 50]],
                    rewardItem: [['random_equip_6', 1, 100]],
                    successor: [1059],
                    forfeit: false
                },
                1060: {
                    name: '魔物扫荡：盐壳龟',
                    category: 'repeat',
                    desc: '清理千针石林周边的魔物',
                    target: '击败50只盐壳龟',
                    lv: 45,
                    reqs: [['slain', 41, 50]],
                    reward: [['gold', 13500], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_3', 1, 100]],
                    successor: [1060],
                    forfeit: false
                },
                1063: {
                    name: '魔物扫荡：盐壳龟精英',
                    category: 'repeat',
                    desc: '清理千针石林周边的魔物',
                    target: '击败10只盐壳龟精英',
                    lv: 45,
                    reqs: [['slain', 43, 10]],
                    reward: [['gold', 20250], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 47,}]],
                    successor: [1063],
                    forfeit: false
                },
                1070: {
                    name: '魔物扫荡：钳嘴龟',
                    category: 'repeat', 
                    desc: '清理千针石林周边的魔物',
                    target: '击败50只钳嘴龟',
                    lv: 50,
                    reqs: [['slain', 42, 50]],
                    reward: [['gold', 16200], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_3', 1, 100]],
                    successor: [1070],
                    forfeit: false
                },
                1073: {
                    name: '魔物扫荡：钳嘴龟精英',
                    category: 'repeat', 
                    desc: '清理千针石林周边的魔物',
                    target: '击败10只钳嘴龟精英',
                    lv: 50,
                    reqs: [['slain', 44, 10]],
                    reward: [['gold', 24300], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 52}]],
                    successor: [1073],
                    forfeit: false
                },
                1079: {
                    name: '魔物扫荡：铁背龟',
                    category: 'repeat', 
                    desc: '击败千针石林地区首领',
                    target: '击败5只铁背龟',
                    lv: 50,
                    reqs: [['slain', 45, 5]],
                    reward: [['gold', 90000], ['guildReputation', 50]],
                    rewardItem: [['random_equip_6', 1, 100]],
                    successor: [1079],
                    forfeit: false
                },
                1080: {
                    name: '魔物扫荡：灼热元素',
                    category: 'repeat',
                    desc: '清理灼热峡谷周边的魔物',
                    target: '击败50只灼热元素',
                    lv: 55,
                    reqs: [['slain', 41, 50]],
                    reward: [['gold', 20200], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_3', 1, 100]],
                    successor: [1080],
                    forfeit: false
                },
                1083: {
                    name: '魔物扫荡：灼热元素精英',
                    category: 'repeat',
                    desc: '清理灼热峡谷周边的魔物',
                    target: '击败10只灼热元素精英',
                    lv: 55,
                    reqs: [['slain', 43, 10]],
                    reward: [['gold', 30300], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 57,}]],
                    successor: [1083],
                    forfeit: false
                },
                1090: {
                    name: '魔物扫荡：熔岩元素',
                    category: 'repeat', 
                    desc: '清理灼热峡谷周边的魔物',
                    target: '击败50只熔岩元素',
                    lv: 60,
                    reqs: [['slain', 42, 50]],
                    reward: [['gold', 24300], ['guildReputation', 10]],
                    rewardItem: [['random_equip_normal_3', 1, 100]],
                    successor: [1090],
                    forfeit: false
                },
                1093: {
                    name: '魔物扫荡：熔岩元素精英',
                    category: 'repeat', 
                    desc: '清理灼热峡谷周边的魔物',
                    target: '击败10只熔岩元素精英',
                    lv: 60,
                    reqs: [['slain', 44, 10]],
                    reward: [['gold', 36450], ['guildReputation', 20]],
                    rewardItem: [['random_equip_elite_4', 1, 100, {lv: 62}]],
                    successor: [1093],
                    forfeit: false
                },
                1099: {
                    name: '魔物扫荡：地狱元素',
                    category: 'repeat', 
                    desc: '击败灼热峡谷地区首领',
                    target: '击败5只地狱元素',
                    lv: 60,
                    reqs: [['slain', 45, 5]],
                    reward: [['gold', 150000], ['guildReputation', 50]],
                    rewardItem: [['random_equip_6', 1, 100]],
                    successor: [1099],
                    forfeit: false
                },
            }
        }
    }
}